module.exports = "https://img.xiyuyouxi.com/saas/img/mine_menu8.8733788c.png";